import React from "react"
import { AspectRatio, Box, Image } from "@chakra-ui/react"

import { scaleShopifyImage } from "@app/utils/image"

type Props = {
  image?: { src?: string; alt?: string } | null
  label: string
  isActive: boolean
  isGreyed?: boolean
  isStrikethrough?: boolean
  isSelectable?: boolean
  onSelect: () => void
}

// A single thumbnail tile in the quick add drawer's option grid. Encodes the availability
// visual states: active (border), greyed (unavailable), and strikethrough (OOS no-action).
export const QuickAddVariantSwatch: React.FC<Props> = React.memo(
  ({ image, label, isActive, isGreyed = false, isStrikethrough = false, isSelectable = true, onSelect }) => (
    <Box width={{ base: "calc((100% - 32px) / 5)", sm: "64px" }}>
      <AspectRatio ratio={64 / 70} backgroundColor="grey.lightest" borderRadius="8px" width="full">
        <Box
          as="button"
          type="button"
          title={label}
          aria-label={label}
          aria-pressed={isActive}
          aria-disabled={!isSelectable}
          disabled={!isSelectable}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            e.stopPropagation()
            if (isSelectable) onSelect()
          }}
          position="relative"
          borderRadius="inherit"
          overflow="hidden"
          border="1px solid"
          borderColor={isActive ? "border.dark" : "border.lighter"}
          p={1}
          cursor={isSelectable ? "pointer" : "not-allowed"}
          pointerEvents={isSelectable ? "auto" : "none"}
          transition="all .3s ease"
          _hover={isSelectable ? { transform: "scale(1.05)" } : undefined}
        >
          <Image
            src={scaleShopifyImage(image?.src, "128x128")}
            alt={image?.alt || label}
            objectFit="contain"
            boxSize="100%"
            objectPosition="center"
            loading="lazy"
            opacity={isGreyed ? 0.4 : 1}
          />
          {isStrikethrough && (
            <Box
              position="absolute"
              inset="0"
              pointerEvents="none"
              sx={{
                background:
                  "linear-gradient(to top right, transparent calc(50% - 0.5px), var(--chakra-colors-secondary-grey) calc(50% - 0.5px), var(--chakra-colors-secondary-grey) calc(50% + 0.5px), transparent calc(50% + 0.5px))",
              }}
            />
          )}
        </Box>
      </AspectRatio>
    </Box>
  )
)
